import {NgModule} from "@angular/core";
import {MøteOpprettDialogKomponentAvhengigheter} from "web-ng2/moduler/møte/modale/møte-opprett-dialog/møte-opprett-dialog";
import {MøteRedigerDialogKomponentAvhengigheter} from "web-ng2/moduler/møte/modale/møte-rediger-dialog/møte-rediger-dialog";
import {KopierMøteDialogKomponentAvhengigheter} from "web-ng2/moduler/møte/modale/kopier-møte-dialog/kopier-møte-dialog";
import {MøtePubliserDialogKomponentAvhengigheter} from "web-ng2/moduler/møte/modale/møte-publiser-dialog/møte-publiser-dialog";
import {MøteVisDeltakereKontrollerAvhengigheter} from "web-ng2/moduler/møte/komponenter/møte-vis-deltakere/møte-vis-deltakere";
import {HorisontalMøtenavigasjonKomponentAvhengigheter} from "web-ng2/moduler/møte/komponenter/horisontal-møtenavigasjon/horisontal-møtenavigasjon";
import {SendMøteinnkallingDialogKomponentAvhengigheter} from "./modale/send-møteinnkalling-dialog/send-møteinnkalling-dialog";
import {MøteTilgjengelighetForVelgMøterKomponent_DI_TOKEN, StandardMøteTilgjengelighetForVelgMøterKomponent, VelgMøteKomponentAvhengigheter} from "web-ng2/moduler/møte/komponenter/velg-møter/velg-møter";
import {AvstemningerListeKomponentAvhengigheter} from "web-ng2/moduler/avstemning/komponenter/avstemninger-liste/avstemninger-liste";
import {MøteLydopptakInnspillingKomponentAvhengigheter} from "web-ng2/moduler/møte/komponenter/møte-lydopptak-innspilling/møte-lydopptak-innspilling";
import {AvsluttMøteTranskripsjonDialogKomponentAvhengigheter} from "web-ng2/moduler/møte/modale/avslutt-møte-transkripsjon-dialog/avslutt-møte-transkripsjon-dialog";
import {StartMøteTranskripsjonDialogKomponentAvhengigheter} from "web-ng2/moduler/møte/modale/start-møte-transkripsjon-dialog/start-møte-transkripsjon-dialog";
import {Møtedialoger} from "web-ng2/moduler/møte/tjenester/Møtedialoger";
import {MøteTranskripsjon} from "web-ng2/moduler/møte/tjenester/MøteTranskripsjon";

@NgModule({
    providers: [
        Møtedialoger,
        MøteTranskripsjon,
        MøteOpprettDialogKomponentAvhengigheter,
        MøteRedigerDialogKomponentAvhengigheter,
        KopierMøteDialogKomponentAvhengigheter,
        MøtePubliserDialogKomponentAvhengigheter,
        MøteVisDeltakereKontrollerAvhengigheter,
        HorisontalMøtenavigasjonKomponentAvhengigheter,
        SendMøteinnkallingDialogKomponentAvhengigheter,
        VelgMøteKomponentAvhengigheter,
        {provide: MøteTilgjengelighetForVelgMøterKomponent_DI_TOKEN, useClass: StandardMøteTilgjengelighetForVelgMøterKomponent},
        MøteLydopptakInnspillingKomponentAvhengigheter,
        AvsluttMøteTranskripsjonDialogKomponentAvhengigheter,
        StartMøteTranskripsjonDialogKomponentAvhengigheter
    ]
})
export class MøteModul {

}
